<template>
  <div id="app">
    <cheader>
    </cheader>
    <div class="main-content">
      <keep-alive>
        <transition :name="transitionName">
          <router-view :key="key"/>
        </transition>
      </keep-alive>
    </div>
    <cfooter>
    </cfooter>
  </div>
</template>

<script>
  import cheader from './components/cheader.vue'
  import cfooter from './components/cfooter.vue'

  export default {
    name: 'App',
    data() {
      return {
        transitionName: ''
      }
    },
    computed: {
      loading() {
        return this.$store.state.loading
      },
      key () {
        return this.$route.name?this.$route.name+ +new Date(): this.$route+ +new Date()
      }
    },
    components: { // 组件
      cheader,
      cfooter
    },
    methods: {
      isPc () {
        let userAgentInfo = navigator.userAgent;
        let Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      init() {
        //代码体
        function isPc() {
          let userAgentInfo = navigator.userAgent;
          let Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone",
            "iPad", "iPod"];
          let flag = true;
          for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
              flag = false;
              break;
            }
          }
          return flag;
        }

        function getUrlParams(name) { //获取url参数
          var reg = new RegExp("[&|?]" + name + "=([^&]*)(&|$)");
          var r = window.location.hash.match(reg);
          if (r) {
            return r[1]
          } else {
            return ""
          }
        }

        let flag = isPc();
        if (flag === true) {
        } else {
          let activty_id = getUrlParams('id');
          if (activty_id) {
            window.location.href='http://webphone.zggz.org.cn/login?id=' + activty_id
            // window.location.href='https://www.baidu.com/'
          } else {
            // window.location.href='https://lol.qq.com/main.shtml'
            window.location.href='http://webphone.zggz.org.cn/'
          }
        }
      }
    },
    beforeCreate () {
      // function isPc() {
      //   let userAgentInfo = navigator.userAgent;
      //   let Agents = ["Android", "iPhone",
      //     "SymbianOS", "Windows Phone",
      //     "iPad", "iPod"];
      //   let flag = true;
      //   for (let v = 0; v < Agents.length; v++) {
      //     if (userAgentInfo.indexOf(Agents[v]) > 0) {
      //       flag = false;
      //       break;
      //     }
      //   }
      //   return flag;
      // }
      // let flag = isPc();
      // if (flag === true) {
      // } else {
      //   window.location.href='http://webphone.zggz.org.cn'
      // }
    },
    created () {
      this.init()
    },
    mounted() {
      let Path = this.$route.path;
      let Arr = this.$router.options.routes;
      let newNavValueArr = Arr.filter(
        function (item) {
          return item.path === Path
        }
      );
      this.$store.commit('changeHomeNavValue', {name: newNavValueArr[0].title})
    },
    watch: {
      $route(to, from) {
        // this.$store.commit('changeLoadingStatus');
        if (to.meta.index > from.meta.index) {
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }
      }
    }
  }
</script>

<style>
  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    font-family: microsoft yahei !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
    padding: 0;
  }

  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 500ms;
  }

  .slide-right-enter {
    opacity: 0;
  }

  .slide-right-leave-active {
    opacity: 0;
  }

  .slide-left-enter {
    opacity: 0;
  }

  .slide-left-leave-active {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue